import Axios from "axios";
import {
    GET_JULY_FIGHTERS
} from "../../mutation-types";
import {
    getJulyFighters
} from "../../api";


const state = {
    getJulyFighterList: [],

};
const getters = {
    getJulyFighterList() {
        return state.getJulyFighterList;
    }
};

const mutations = {
    [GET_JULY_FIGHTERS](state, result) {
        state.getJulyFighterList = result;
    },
};
const actions = {
    fetchJulyFighterData({
        commit
    }, searchParam) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {
                color: "primary"
            });
            Axios.get(getJulyFighters, {
                params: searchParam,
            })
                .then(function (response) {
                    commit("UNSET_LOADING"); // loading Closing
                    var result = response.data;
                    console.log("Tanvir, this is july fighter data->", result);
                    commit("GET_JULY_FIGHTERS", result);
                    resolve(response.data);
                })
                .catch(function (error) {
                    commit("UNSET_LOADING"); // loading Closing
                    console.log(error);
                    reject();
                });
        });
    },

    postJulyFighterData({ commit }, peram) {
        console.log("This is from api", peram);
        commit("SET_ACTION_PROCESS");
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {
                color: "Primary"
            });
            Axios.post(getJulyFighters, peram)
                .then((response) => {
                    commit("UNSET_LOADING");
                    if (response.data.status == "success") {
                        console.log("Tanvir, July Fighter created successfully!!");
                        commit("SET_SNACKBAR", {
                            msg: response.data.message,
                            color: "green"
                        });
                        commit("UNSET_FORMNOTIFY");
                        resolve(response.data.message);
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message,
                            color: "red",
                            timeout: 10000
                        });
                        commit("UNSET_FORMNOTIFY", {
                            type: "error",
                            msg: response.data.message
                        });
                        reject(response.data.message);
                    }
                })
                .catch((error) => {
                    commit("UNSET_LOADING");
                    commit("SET_SNACKBAR", {
                        msg: "Process failed. Please try again !!!",
                        color: "red"
                    });
                    reject(error)
                });
        });
    },

    deleteJulyFighterData({ commit }, id) {
        console.log("Deleting July Fighter with ID:", id);
        commit("SET_ACTION_PROCESS");

        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {
                color: "primary"
            });

            Axios.delete(`${getJulyFighters}/${id}`)
                .then((response) => {
                    commit("UNSET_LOADING");

                    if (response.data.status === "success") {
                        console.log("Tanvir, July Fighter deleted successfully!!");
                        commit("SET_SNACKBAR", {
                            msg: response.data.message,
                            color: "green"
                        });
                        commit("UNSET_FORMNOTIFY");
                        resolve(response.data.message);
                    } else {
                        commit("SET_SNACKBAR", {
                            msg: response.data.message,
                            color: "red",
                            timeout: 10000
                        });
                        commit("UNSET_FORMNOTIFY", {
                            type: "error",
                            msg: response.data.message
                        });
                        reject(response.data.message);
                    }
                })
                .catch((error) => {
                    commit("UNSET_LOADING");
                    commit("SET_SNACKBAR", {
                        msg: "Delete process failed. Please try again !!!",
                        color: "red"
                    });
                    reject(error);
                });
        });
    },




};


export default {
    state,
    getters,
    actions,
    mutations,
};